<template>
    <v-card shaped class="rounded-card mx-auto mt-5 item" max-width="344" height="300px" @click="showItem">
        <div class="text-center">
            <img :src="`/images/health/${item.slug}.png`">
        </div>
        <div class="d-flex">
            <v-card-title>{{ item.name }}</v-card-title>
            <div class="price">
                <p>${{ formatAmount(item.price/400) }}/month</p>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    props: getProps(),
    methods: {
        showItem() {
            this.$emit('view-item', this.item);
        },
    }
}

function getProps() {
    return {
        item: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style>
.item {
    cursor: pointer;
    max-height: 350px;
}

.item .v-card__title {
    font-size: 1rem;
}

.d-flex .price {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #3F51B5;
}

.item img {
    height: 175px;
    margin-top: 40px;
    width: 175px;
}

.item .actions {
    position: absolute;
    bottom: 0px;
    background-color: #EBEBEB;
    background-color: #3F51B5;
    width: 100%;
    display: none;
}

.item:hover .actions {
    /* display: flex; */
    transition: display 2s ease;
}

.line {
    border-right: 1px solid #fff;
    height: 35px;
}
</style>
